module.exports = __webpack_public_path__ + "static/img/app-logo.93714be7.png";